class AlDeliveryTimeline extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    this.update();
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) this.update();
    }, { signal: this.abort.signal });
  }

  disconnectedCallback() {
    this.abort?.abort();
    clearTimeout(this.midnightTimer);
  }

  update() {
    const today = new Date();
    const format = new Intl.DateTimeFormat(this.dataset.locale || 'en-AU', { day: 'numeric', month: 'short' });
    const future = offset => {
      const date = new Date(today);
      date.setHours(12, 0, 0, 0);
      date.setDate(date.getDate() + offset);
      return format.format(date);
    };
    const range = (minimum, maximum) => minimum === maximum ? future(minimum) : `${future(minimum)} – ${future(maximum)}`;
    const shipMin = Math.max(0, Number(this.dataset.shipMin));
    const shipMax = Math.max(shipMin, Number(this.dataset.shipMax));
    const deliveryMin = Math.max(shipMin, Number(this.dataset.deliveryMin));
    const deliveryMax = Math.max(deliveryMin, Number(this.dataset.deliveryMax));
    this.querySelector('[data-shipping-date]').textContent = range(shipMin, shipMax);
    this.querySelector('[data-delivery-date]').textContent = range(deliveryMin, deliveryMax);
    const midnight = new Date(today);
    midnight.setDate(midnight.getDate() + 1);
    midnight.setHours(0, 0, 1, 0);
    clearTimeout(this.midnightTimer);
    this.midnightTimer = setTimeout(() => this.update(), midnight - today);
  }
}

if (!customElements.get('al-delivery-timeline')) customElements.define('al-delivery-timeline', AlDeliveryTimeline);
